module.exports = __webpack_public_path__ + "static/media/giraffe.24bf5144.png";